import type { ResponseModel } from "../modelli";

export const responseModels: ResponseModel[] = [
  { id: "futura-balanced", name: "Futura Balanced", description: "Risposte chiare e approfondite per il lavoro quotidiano.", recommended: true },
  { id: "futura-quick", name: "Futura Quick", description: "Risposte più rapide per domande semplici e operative.", recommended: false },
  { id: "futura-deep", name: "Futura Deep", description: "Analisi più articolate per richieste complesse.", recommended: false },
];
